import React from 'react';
import { motion } from 'framer-motion';
const WhatsAppIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-293">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-294" />
  </svg>;
export function Servicios() {
  const serviciosBasicos = [{
    name: 'Corte',
    price: '$15.000'
  }, {
    name: 'Barba Afeitada',
    price: '$5.000'
  }, {
    name: 'Barba Premium',
    price: '$10.000'
  }, {
    name: 'Lavado',
    price: '$5.000'
  }, {
    name: 'Cejas Afiladas',
    price: '$2.000'
  }, {
    name: 'Cejas y Bozo c/cera',
    price: '$6.000'
  }];
  const paquetes = [{
    name: 'Corte, línea y cejas',
    price: '$17.000'
  }, {
    name: 'Corte, barba y cejas',
    price: '$20.000'
  }, {
    name: 'Barba y cejas',
    price: '$20.000'
  }, {
    name: 'Servicio Premium',
    price: '$25.000'
  }, {
    name: 'Corte y Facial',
    price: '$22.000'
  }, {
    name: 'Corte cejas c/cera',
    price: '$20.000'
  }];
  const otros = [{
    name: 'Facial Express',
    price: '$7.000'
  }, {
    name: 'Tinte Barba',
    price: '$15.000'
  }, {
    name: 'Facial Completo',
    price: '$40.000'
  }, {
    name: 'Tratamiento Barba (Minoxidil)',
    price: '$120.000'
  }];
  const productos = ['Gel para afeitar', 'Shampoo especializado', 'Mascarilla capilar', 'Ceras para el cabello', 'Gel para el cabello', 'Aceite para barba'];
  return <section id="servicios" className="py-20 bg-deepblack" data-id="element-295">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-296">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-297">
          <div className="text-gold text-sm font-bold tracking-widest uppercase mb-4" data-id="element-298">
            SERVICIOS
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-bone mb-4" data-id="element-299">
            Todos Nuestros Servicios
          </h2>
          <p className="text-bone text-lg" data-id="element-300">
            Calidad profesional a precios justos
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-301">
          {/* SERVICIOS BÁSICOS */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-deepblack border border-gold rounded-lg p-6" data-id="element-302">
            <h3 className="text-gold text-xl font-bold mb-6" data-id="element-303">
              SERVICIOS BÁSICOS
            </h3>
            <div className="space-y-3" data-id="element-304">
              {serviciosBasicos.map((servicio, index) => <div key={index} className="flex justify-between items-center border-b border-gold/20 pb-2" data-id="element-305">
                  <span className="text-bone" data-id="element-306">{servicio.name}</span>
                  <span className="text-gold font-semibold" data-id="element-307">
                    {servicio.price}
                  </span>
                </div>)}
            </div>
          </motion.div>

          {/* PAQUETES */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-deepblack border border-gold rounded-lg p-6" data-id="element-308">
            <h3 className="text-gold text-xl font-bold mb-6" data-id="element-309">PAQUETES</h3>
            <div className="space-y-3" data-id="element-310">
              {paquetes.map((paquete, index) => <div key={index} className="flex justify-between items-center border-b border-gold/20 pb-2" data-id="element-311">
                  <span className="text-bone" data-id="element-312">{paquete.name}</span>
                  <span className="text-gold font-semibold" data-id="element-313">
                    {paquete.price}
                  </span>
                </div>)}
            </div>
          </motion.div>

          {/* OTROS SERVICIOS */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-deepblack border border-gold rounded-lg p-6" data-id="element-314">
            <h3 className="text-gold text-xl font-bold mb-6" data-id="element-315">
              OTROS SERVICIOS
            </h3>
            <div className="space-y-3" data-id="element-316">
              {otros.map((servicio, index) => <div key={index} className="flex justify-between items-center border-b border-gold/20 pb-2" data-id="element-317">
                  <span className="text-bone" data-id="element-318">{servicio.name}</span>
                  <span className="text-gold font-semibold" data-id="element-319">
                    {servicio.price}
                  </span>
                </div>)}
            </div>
          </motion.div>

          {/* PRODUCTOS */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-deepblack border border-gold rounded-lg p-6" data-id="element-320">
            <h3 className="text-gold text-xl font-bold mb-6" data-id="element-321">PRODUCTOS</h3>
            <ul className="space-y-3" data-id="element-322">
              {productos.map((producto, index) => <li key={index} className="text-bone flex items-center gap-3" data-id="element-323">
                  <span className="w-2 h-2 bg-gold rounded-full" data-id="element-324"></span>
                  {producto}
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-325">
          <a href="https://wa.me/573028281216" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-gold text-deepblack px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-500 transition-all shadow-lg hover:shadow-gold-glow" data-id="element-326">
            <WhatsAppIcon data-id="element-327" />
            Preguntar por un Servicio
          </a>
        </motion.div>
      </div>
    </section>;
}